<template>
  <nav class="flex min-h-full flex-col space-y-5 text-sm" aria-label="Main navigation">
    <div v-if="!isAgency">
      <p class="mb-1.5 px-2 text-[11px] font-semibold uppercase tracking-wide text-gray-400">
        Overview
      </p>
      <Link
        href="/"
        class="group flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium transition-colors"
        :class="linkClass('')"
        :aria-current="isUrl('') ? 'page' : undefined"
      >
        <icon name="dashboard" class="h-5 w-5 flex-shrink-0" />
        <span class="truncate">Dashboard</span>
      </Link>
    </div>

    <div class="space-y-1">
      <p class="mb-1.5 px-2 text-[11px] font-semibold uppercase tracking-wide text-gray-400">
        Operations
      </p>

      <Link
        href="/custmanagement"
        class="group flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium transition-colors"
        :class="linkClass('custmanagement')"
        :aria-current="isUrl('custmanagement') ? 'page' : undefined"
      >
        <icon name="office" class="h-5 w-5 flex-shrink-0" />
        <span class="truncate">Tracking Management</span>
      </Link>

      <Link
        href="/campaign"
        class="group flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium transition-colors"
        :class="linkClass('campaign')"
        :aria-current="isUrl('campaign') ? 'page' : undefined"
      >
        <icon name="globe" class="h-5 w-5 flex-shrink-0" />
        <span class="truncate">Campaign</span>
      </Link>

      <Link
        href="/channel"
        class="group flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium transition-colors"
        :class="linkClass('channel')"
        :aria-current="isUrl('channel') ? 'page' : undefined"
      >
        <icon name="channel" class="h-5 w-5 flex-shrink-0" />
        <span class="truncate">Channel</span>
      </Link>

      <Link
        v-if="!isAgency"
        href="/pending-submissions"
        class="group flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium transition-colors"
        :class="linkClass('pending-submissions')"
        :aria-current="isUrl('pending-submissions') ? 'page' : undefined"
      >
        <icon name="office" class="h-5 w-5 flex-shrink-0" />
        <span class="truncate">Pending Submissions</span>
      </Link>

      <Link
        v-if="!isAgency"
        href="/submissionweb"
        class="group flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium transition-colors"
        :class="linkClass('submissionweb')"
        :aria-current="isUrl('submissionweb') ? 'page' : undefined"
      >
        <icon name="globe" class="h-5 w-5 flex-shrink-0" />
        <span class="truncate">Submission (Web)</span>
      </Link>

      <Link
        v-if="!isAgency"
        href="/submissionmobile"
        class="group flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium transition-colors"
        :class="linkClass('submissionmobile')"
        :aria-current="isUrl('submissionmobile') ? 'page' : undefined"
      >
        <icon name="office" class="h-5 w-5 flex-shrink-0" />
        <span class="truncate">Submission (App)</span>
      </Link>
    </div>

    <div v-if="!isAgency" class="space-y-1">
      <p class="mb-1.5 px-2 text-[11px] font-semibold uppercase tracking-wide text-gray-400">
        Administration
      </p>

      <Link
        href="/users"
        class="group flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium transition-colors"
        :class="linkClass('users')"
        :aria-current="isUrl('users') ? 'page' : undefined"
      >
        <icon name="users" class="h-5 w-5 flex-shrink-0" />
        <span class="truncate">Users</span>
      </Link>
    </div>
  </nav>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'

export default {
  components: {
    Icon,
    Link,
  },
  computed: {
    isAgency() {
      return this.$page.props.auth.user?.role === 'agency'
    },
  },
  methods: {
    isUrl(...urls) {
      const currentUrl = this.$page.url.substr(1)
      if (urls[0] === '') {
        return currentUrl === ''
      }
      return urls.filter((url) => currentUrl.startsWith(url)).length
    },
    linkClass(url) {
      const isActive = this.isUrl(url)
      if (isActive) {
        return 'bg-brand-50 text-brand-800 shadow-sm ring-1 ring-brand-100'
      }

      return 'text-gray-600 hover:bg-gray-50 hover:text-brand-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-200'
    },
  },
}
</script>
